/**
 * Function to determine if a hexadecimal color is light or dark
 * @param {string} hex - Hexadecimal color value (e.g. "#ff5733" or "ff5733")
 * @return {string} "light" or "dark"
 */
export const getColorShade = (hex: string) => {
  let color = hex.replace(/^#/, '');

  // Convert 3-digit hex to 6-digit
  if (color.length === 3) {
    color = color
      .split('')
      .map(c => c + c)
      .join('');
  }

  if (color.length !== 6) {
    throw new Error('Invalid HEX color format');
  }

  const rgb = parseInt(color, 16);
  const red = (rgb >> 16) & 0xff; // extract red
  const green = (rgb >> 8) & 0xff; // extract green
  const blue = (rgb >> 0) & 0xff; // extract blue

  // Calculate relative luminance (per WCAG formula) - https://www.w3.org/WAI/GL/wiki/Relative_luminance
  const luminance = 0.2126 * red + 0.7152 * green + 0.0722 * blue;

  // Return based on threshold
  return luminance > 128 ? 'light' : 'dark';
};
